import { useQuery } from "@tanstack/react-query";
import { useContext, useEffect, useState } from "react";
import { getQuotations } from "../../../api/quotation";
import { Loader } from "../../../components/widgets/Loader";
import { brand } from "../../../context";
import { useApoAuth } from "../../../hooks";
import { TranslationContext } from "../../../umbilical_tools";
import { QuotationFilters, type QuotationFiltersType } from "./QuotationFilters";
import { QuotationRequestDesktopTable } from "./QuotationRequestDesktopTable";
import { QuotationRequestMobileTable } from "./QuotationRequestMobileTable";

export function Quotations() {
  const [token, setToken] = useState<string | null>(null);
  const [filters, setFilters] = useState<QuotationFiltersType>({});
  const { getIdTokenClaims, source_entity } = useApoAuth();
  const { t } = useContext(TranslationContext) as { t: (key: string) => string };

  // Get and set token
  useEffect(() => {
    getIdTokenClaims().then((data) => !!data && setToken(data.__raw));
  }, [getIdTokenClaims]);

  const { data, isLoading } = useQuery({
    queryKey: ["myquotations", token, filters],
    queryFn: () => {
      const params: Record<string, string> = { source_entity };
      if (filters.title) params.title = filters.title;
      if (filters.created_from) params.created_from = filters.created_from;
      if (filters.created_to) params.created_to = filters.created_to;
      if (filters.offer_status) params.offer_status = filters.offer_status;
      return getQuotations({ token: token as string, params });
    },
    enabled: !!token,
    refetchOnWindowFocus: false,
  });
  const quotations = data?.data?.results ?? [];

  return (
    <div className="Quotations Card" data-brand={brand}>
      <div className="Card__header">
        <h5>{t("myQuotations")}</h5>
      </div>
      <div className="Card__body Quotations__body">
        <div className="hidden md:block!">
          <QuotationFilters
            filters={filters}
            onApply={(newFilters) => setFilters(newFilters)}
            onReset={() => setFilters({})}
          />
        </div>
        {isLoading ? (
          <div className="grid place-items-center p-8 min-h-[200px]">
            <Loader size="lg" />
          </div>
        ) : (
          <>
            <QuotationRequestMobileTable quotations={quotations} />
            <QuotationRequestDesktopTable quotations={quotations} />
          </>
        )}
      </div>
    </div>
  );
}
